import 'promise-polyfill/src/polyfill';
import 'core-js/es/symbol';
import Vue from "vue";
import Vuex from "vuex";
import { defaults, forEach, defaultsDeep, cloneDeep } from 'lodash';
import VueGtag from 'vue-gtag';
import App from "./App.vue";
import store from "./store";
import components from './components.js';
import './filters';

Vue.config.productionTip = false;

import './main.scss';

class FitModeller {

  components = components;

  vueOptions = {
    store,
    render: h => h(App),
  }

  constructor(opts) {
    this.vueOptions = defaultsDeep(opts.vueOptions, this.vueOptions);
    this.vueOptions.store = new Vuex.Store({...this.vueOptions.store})
    this.components = defaults(opts.components, this.components);
  }

  init(htmlElement) {
    forEach(this.components, (value, key) => {
      Vue.component(key, value);
    });

    const analyticsConfig = this.vueOptions.store.getters.Config.analytics;
    if (analyticsConfig && analyticsConfig.id) {
      Vue.use(VueGtag, { config: { ...analyticsConfig } });
    }

    new Vue(this.vueOptions).$mount(htmlElement);
  }
}

export default FitModeller;
